import { AdminRole, AdminRoleName } from 'constants/AdminRole';
import routes from '../routes';

const SUPER_ADMIN_ROUTES = routes.filter(
  (item) => item.access && !item.access.includes(AdminRoleName.DASHBOARD),
);
const ADMIN_ROUTES = routes.filter(
  (item) => item.access && item.access.includes(AdminRoleName.ADMIN),
);
const DASHBOARD_ROUTES = routes.filter(
  (item) => item.access && item.access.includes(AdminRoleName.DASHBOARD),
);

export const accessRoutes = (accountType) => {
  if (accountType === AdminRole.SUPER_ADMIN) {
    return SUPER_ADMIN_ROUTES;
  }

  if (accountType === AdminRole.ADMIN) {
    return ADMIN_ROUTES;
  }

  return DASHBOARD_ROUTES;
};
